export const reportsActions = {
    GET_INSTANCES: 'GET_INSTANCES',
    SET_INSTANCES: 'SET_INSTANCES',
    GET_SCHEMAS_FOR_REPORT: 'GET_SCHEMAS_FOR_REPORT',
    SET_SCHEMAS_FOR_REPORT: 'SET_SCHEMAS_FOR_REPORT',
    GET_AUDIT_REPORT_DETAILS: 'GET_AUDIT_REPORT_DETAILS',
    SET_AUDIT_REPORT_DETAILS:'SET_AUDIT_REPORT_DETAILS',
    GET_AUDIT_REPORT_SUMMERY:'GET_AUDIT_REPORT_SUMMERY',
    SET_AUDIT_REPORT_SUMMERY:'SET_AUDIT_REPORT_SUMMERY',

    GET_ALL_INSTANCES:'GET_ALL_INSTANCES',
    SET_ALL_INSTANCES:'SET_ALL_INSTANCES',
    GET_DEPLOYED_PACKAGES: 'GET_DEPLOYED_PACKAGES',
    SET_DEPLOYED_PACKAGES: 'SET_DEPLOYED_PACKAGES',
    GET_SCHEMAS_FOR_REPORT_DEAILS:'GET_SCHEMAS_FOR_REPORT_DEAILS',
    SET_SCHEMAS_FOR_REPORT_DEAILS:'SET_SCHEMAS_FOR_REPORT_DEAILS'
};

const initState = {
    reports: []
};

export const reportsReducer = (state = initState, action: any) => {
    switch (action.type) {
        case reportsActions.SET_DEPLOYED_PACKAGES:
        case reportsActions.SET_INSTANCES:
        case reportsActions.SET_ALL_INSTANCES:
        case reportsActions.SET_SCHEMAS_FOR_REPORT_DEAILS:
        case reportsActions.SET_SCHEMAS_FOR_REPORT:
        case reportsActions.SET_AUDIT_REPORT_SUMMERY:
        case reportsActions.SET_AUDIT_REPORT_DETAILS:
            return Object.assign({}, state, action.payload);

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/reportsReducer.ts